import { type Language } from '@/utils/languageUtils';
import svLocale from '../locales/sv/admin.json';
import enLocale from '../locales/en/admin.json';

const getAdminLocale = (lang?: Language) => {
  switch (lang) {
    case 'en':
      return enLocale;
    case 'sv':
    default:
      return svLocale;
  }
};

export const adminLabels = (lang?: Language) => {
  const locale = getAdminLocale(lang);
  return locale;
};


